import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Settings, Save } from 'lucide-react';

const ContributorSettings = ({ settings, setSettings, savingSettings, onSave }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Settings className="w-5 h-5" />
          Compensation Settings
        </CardTitle>
        <CardDescription>Configure eligibility requirements and revenue sharing</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        {/* Eligibility Threshold */}
        <div className="space-y-2">
          <Label htmlFor="threshold">Points Required for Eligibility</Label>
          <p className="text-sm text-gray-500">
            Contributors must earn this many points per month to qualify for compensation.
          </p>
          <div className="flex items-center gap-3">
            <Input
              id="threshold"
              type="number"
              min="1"
              max="1000"
              value={settings.eligibility_threshold}
              onChange={(e) => setSettings(s => ({ ...s, eligibility_threshold: parseInt(e.target.value) || 1 }))}
              className="w-32"
            />
            <span className="text-gray-400">points per month</span>
          </div>
        </div>
        
        {/* Revenue Share Percentage */}
        <div className="space-y-2">
          <Label htmlFor="share">Revenue Share Percentage</Label>
          <p className="text-sm text-gray-500">
            Percentage of monthly membership revenue allocated to the contributor pool.
          </p>
          <div className="flex items-center gap-3">
            <Input
              id="share"
              type="number"
              min="1"
              max="50"
              value={settings.revenue_share_percentage}
              onChange={(e) => setSettings(s => ({ ...s, revenue_share_percentage: parseFloat(e.target.value) || 1 }))}
              className="w-32"
            />
            <span className="text-gray-400">%</span>
          </div>
        </div>
        
        {/* Point Values Info */}
        <div className="space-y-2">
          <Label>Point Values (Reference)</Label>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 p-4 bg-slate-800 rounded-lg">
            <div className="text-center">
              <p className="text-lg font-bold text-cyan-400">1</p>
              <p className="text-xs text-gray-400">Login (daily)</p>
            </div>
            <div className="text-center">
              <p className="text-lg font-bold text-cyan-400">1</p>
              <p className="text-xs text-gray-400">Forum Post</p>
            </div>
            <div className="text-center">
              <p className="text-lg font-bold text-cyan-400">2</p>
              <p className="text-xs text-gray-400">Forum Reply</p>
            </div>
            <div className="text-center">
              <p className="text-lg font-bold text-cyan-400">2</p>
              <p className="text-xs text-gray-400">Homework Review</p>
            </div>
            <div className="text-center">
              <p className="text-lg font-bold text-cyan-400">2</p>
              <p className="text-xs text-gray-400">Feedback Given</p>
            </div>
            <div className="text-center">
              <p className="text-lg font-bold text-cyan-400">2</p>
              <p className="text-xs text-gray-400">Live Stream</p>
            </div>
          </div>
        </div>
        
        {/* Save Button */}
        <Button 
          onClick={onSave}
          disabled={savingSettings}
          className="bg-cyan-600 hover:bg-cyan-700"
        >
          {savingSettings ? (
            <>Saving...</>
          ) : (
            <><Save className="w-4 h-4 mr-2" /> Save Settings</>
          )}
        </Button>
      </CardContent>
    </Card>
  );
};

export default ContributorSettings;
